export default __webpack_public_path__ + "static/media/background.c42d9f63.png";